import styled from 'styled-components';
import { mb, pl } from 'styled-components-spacing';

import theme from '@theme';

export const StyledPoinerList = styled.div`
  ${mb(4.5)}

  &:last-child {
    ${mb(0)}
  }
`;

export const StyledHeadlineText = styled.h3`
  ${mb(4)}
  ${theme.typography.Raleway}
  font-size: 24px;
  font-weight: 600;
`;

export const StyledList = styled.ul`
  ${pl(4)};
  list-style-type: disc;
  font-size: ${({ variant }) => (variant === 'small' ? '16' : '18')}px;
`;

export const StyledListItem = styled.li`
  ${({ variant }) => (variant === 'small' ? mb(2) : mb(3))}

  line-height: 1.3;
  &:last-child {
    ${mb(0)}
  }
`;

export const StyledParagraph = styled.p`
  font-size: 20px;
`;
